import { render, staticRenderFns } from "./Parent_Lerner_Marksheet.vue?vue&type=template&id=c2ccc10e&scoped=true&"
import script from "./Parent_Lerner_Marksheet.vue?vue&type=script&lang=js&"
export * from "./Parent_Lerner_Marksheet.vue?vue&type=script&lang=js&"
import style0 from "./Parent_Lerner_Marksheet.vue?vue&type=style&index=0&id=c2ccc10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ccc10e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VDialog,VRow,VSimpleTable,VSnackbar,VToolbar,VToolbarTitle})
